import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const authData = JSON.parse(localStorage.getItem("auth"));

  if (!authData || !authData.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Check expiry
  if (new Date().getTime() > authData.expiry) {
    localStorage.removeItem("auth");
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;